/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import React from 'react';
import { useSelector } from 'react-redux';
import { Selectors as PlayerSelectors } from 'store/ducks/player';
import { Ducks } from '@wit/vtv-x-foundation-lib';
import { Selectors as GdprSelectors } from 'core/store/ducks/gdpr';

import Recommendations from './Recommendations';

function UpNext(): JSX.Element | null {
  const hasAgreedToConsent = useSelector(GdprSelectors.hasAgreedToConsent);

  const recommendations = useSelector(PlayerSelectors.recommendations);
  const isRecommendationsEnabled = useSelector(Ducks.Recommendations.Selectors.isFeatureEnabled);

  if (
    isRecommendationsEnabled &&
    hasAgreedToConsent &&
    (recommendations.upNext?.assets.length || recommendations.somethingSimilar?.assets.length)
  ) {
    return <Recommendations />;
  }
  return <></>;
}

export default React.memo(UpNext);
